"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M19 1v2H5V1H3v22h2v-2h14v2h2V1zm0 4v6h-6V7H7v4H5V5zm-2 14v-4h-6v4H5v-6h14v6z"
}), 'Shelves');